import DgCard from 'styles/UI/Card/DgCard';
import DgCardHeader from 'styles/UI/CardHeader/DgCardHeader';
import useAdminProduct from './List/hooks/useAdminProduct';
import DgModal from 'styles/UI/Modal/DgModal';
import AdminProductTable from './List/components/AdminProductTable';
import AdminProductUpdate from './Update/AdminProductUpdate';
import { useEffect, useState } from 'react';
import Text from '../../../core/utils/Text';
import { useAdminDeleteProduct } from './Update/hooks/react-query/useAdminDeleteProduct';
import { DotLoader } from 'react-spinners';
import CreateProductModal from './List/components/CreateProductModal';
import { setProductDetail } from 'core/store/slice/product/reducer';
import { useDispatch } from 'react-redux';

const AdminProduct = () => {
	const dispatch = useDispatch();
	const { hideModalHandler, modal, onEditProductHandler } = useAdminProduct();

	/*
	 * delete product
	 */
	const deleteInitial = { show: false, id: null };
	const [deleteModal, setDeleteModal] = useState(deleteInitial);
	const closeDeleteModal = () => setDeleteModal(deleteInitial);
	const onDeleteProductHandler = (record: any) => {
		setDeleteModal({ show: true, id: record?.id });
	};

	const { mutate: deleteProduct, isLoading: deleting } = useAdminDeleteProduct(() => {
		closeDeleteModal();
	});
	const onSubmitDelete = () => {
		if (deleting) return;
		deleteProduct({ id: deleteModal.id });
	};

	/*
	 * create product
	 */
	const [createModal, setCreateModal] = useState(false);
	const showCreateModal = () => setCreateModal(true);
	const hideCreateModal = () => setCreateModal(false);

	useEffect(() => {
		if (!modal) {
			dispatch(setProductDetail({}));
		}
	}, [modal]);

	return (
		<>
			{!!modal && (
				<DgModal title='update-product' open={modal} onCancel={hideModalHandler}>
					<AdminProductUpdate hideModalHandler={hideModalHandler} />
				</DgModal>
			)}

			{createModal && (
				<DgModal title={'create-product'} open={createModal} onCancel={hideCreateModal}>
					<CreateProductModal hideCreateModal={hideCreateModal} />
				</DgModal>
			)}

			{deleteModal.show && (
				<DgModal
					title={'delete-product'}
					open={deleteModal.show}
					onCancel={closeDeleteModal}
				>
					<div>
						<Text tid={'delete-product-desc'} />
					</div>
					<div className={'w-full flex justify-around items-center mt-5'}>
						<div
							className={
								'w-[120px] h-[42px] bg-green-700 rounded flex justify-center items-center cursor-pointer'
							}
							onClick={onSubmitDelete}
						>
							{deleting ? (
								<DotLoader size={16} color={'white'} />
							) : (
								<Text tid={'submitt'} />
							)}
						</div>

						<div
							className={
								'w-[120px] h-[42px] bg-gray-600 rounded flex justify-center items-center cursor-pointer'
							}
							onClick={closeDeleteModal}
						>
							<Text tid={'cancel'} />
						</div>
					</div>
				</DgModal>
			)}

			<DgCard>
				<div className={'flex w-full justify-between'}>
					<DgCardHeader title='product-management' />
					<div
						className={
							'bg-[#58a0f8] rounded-md px-8 h-[42px] flex justify-center items-center text-black cursor-pointer'
						}
						onClick={showCreateModal}
					>
						<Text tid={'create-product'} />
					</div>
				</div>

				<AdminProductTable
					onEditSettingsHandler={onEditProductHandler}
					onDeleteProductHandler={onDeleteProductHandler}
				/>
			</DgCard>
		</>
	);
};

export default AdminProduct;
